import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import Box from "@mui/material/Box";
import Countdown from "react-countdown";
import { getMockCountdownDurationMs } from "./mockExamCountdownConfig";

const CountdownTimer = () => {
  const universityName = useSelector((state) => state.auth.universityName);

  const { targetDate, durationMs } = useMemo(() => {
    const durationMs = getMockCountdownDurationMs(universityName);
    return { durationMs, targetDate: Date.now() + durationMs };
  }, [universityName]);

  const renderer = ({ hours, minutes, seconds, completed }) => {
    if (completed) {
      return <span>Time&apos;s up!</span>;
    }
    return (
      <span>
        Time Left: {String(hours).padStart(2, "0")}:
        {String(minutes).padStart(2, "0")}:
        {String(seconds).padStart(2, "0")}
      </span>
    );
  };

  return (
    <Box component="span" sx={{ display: "inline" }}>
      {/* Remount when duration or uni changes so react-countdown picks up the new end time */}
      <Countdown
        key={`${universityName ?? ""}-${durationMs}`}
        date={targetDate}
        renderer={renderer}
      />
    </Box>
  );
};

export default CountdownTimer;
